/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

export default {
  default: {
    price: 'Giá',
    amount: 'Số lượng',
    total: 'Tổng',
    stop_price: 'Giá dừng',
    price_limit: 'Giá giới hạn',
    address: 'Địa chỉ',

    welcome: 'Hello anh em viet nam',
    'navigation.home_link': 'TrustKeys',
    'navigation.exchange_link': 'Giao dịch',
    'navigation.explore': 'Khám phá',
    'navigation.referral': 'Chương trình liên kết',
    'navigation.campaign': 'Chiến dịch',
    
    'navigation.language_link': 'Ngôn ngữ',
    'navigation.language_sub_en_link': 'English',
    'navigation.language_sub_vi_link': 'Tiếng Việt',
    'navigation.language_sub_korea_link': 'Tiếng Hàn',
    'navigation.sign_out_link': 'Đăng xuất',
    'navigation.login_link': 'Đăng nhập',
    'navigation.wallet_link': 'Ví',
    'navigation.qa_link': 'Hỏi đáp',
    'navigation.tutorial': 'Hướng dẫn',
    'navigation.create_account': 'Tạo Tài Khoản',
    'navigation.create_account_sign_in': 'Đăng nhập',
    'navigation.create_account_sign_out': 'Đăng ký',

    'landing.name': 'Tên',
    'landing.last_price': 'Giá gần nhất',
    'landing.change_24h': 'Biến động giá 24h',
    'landing.high': 'Giá cao nhất',
    'landing.low': 'Giá thấp nhất',
    'landing.volume': 'Khối lượng 24h',
    'landing.text_1': 'Sàn giao dịch tiền mã hoá an toàn',
    'landing.text_2': 'Tham gia sàn giao dịch mua & bán tiền mã hoá an toàn và nhanh chóng nhất',
    'landing.text_3': 'Bắt đầu',
    'landing.text_4': 'Tải App TrustKeys',

    'landing.contact_us': 'Liên hệ chúng tôi',
    'landing.preferential_exchange': 'Ưu đãi sàn giao dịch',
    'landing.new_trading_experience': 'Nâng cao khả năng giao dịch của bạn với trải nghiệm giao dịch mới',
    'landing.check_now': 'Kiểm tra ngay',
    'landing.support_24_7': 'Hỗ trợ khách hàng 24/7',
    'landing.problem': 'Bạn đang gặp vấn đề? Liên lạc với chúng tôi ngay. Đội hỗ trợ của TrustKeys luôn sẵn sàng 24/7',
    'landing.blog': 'TrustKeys Blog',
    'landing.news': 'Tin tức và cập nhật từ sàn giao dịch tiền mã hoá hàng đầu thế giới',
    'landing.community': 'Cộng đồng',
    'landing.join_us': 'Tham gia thảo luận ngay với cộng đồng của chúng tôi trên khắp thế giới',
    'landing.condition': 'Điều kiện để thực hiện với sàn giao dịch TrustKeys?',
    'landing.more': 'Nhiều hơn >',

    'footer.about_us': 'Về chúng tôi',
    'footer.more_info': 'Thông tin thêm',
    'footer.blog': 'TrustKeys Blog',
    'footer.community': 'Cộng đồng',
    'footer.product': 'Sản Phẩm',
    'footer.network': 'TrustKeys Network',
    'footer.social': 'Mạng xã Hội Butta',
    'footer.download_here': 'Tải App tại đây',

    'language.vi': 'Tiếng Việt',
    'language.en': 'Tiếng Anh',

    'login.qr_success': 'Quét mã thành công. Vui lòng chọn "Confirm" trên thiết bị di động của bạn.',
    'login.login_trustkeys': 'Đăng nhập bằng tài khoản TrustKeys',
    'login.new_qr': 'Nhận mã QR mới',
    'login.download_app': 'Tải ứng dụng điện thoại',
    'login.with_qr': 'Đăng nhập với mã QR',

    'login.not_have_account': 'Bạn chưa có tài khoản? ',
    'login.download_trustkeys': 'Tải app TrustKeys ngay nào!',

    'exchange.exchange_select.your_balance': 'Số dư của bạn',
    'exchange.exchange_select.available': 'Có sẵn',
    'exchange.exchange_select.value': 'Giá trị',
    'exchange.exchange_select.my_account': 'Tài khoản của tôi',
    'exchange.exchange_select.dashboard': 'Trang cá nhân',
    'exchange.exchange_select.user_info': 'Thông tin của tôi',
    'exchange.exchange_select.logout': 'Đăng xuất',
    'exchange.exchange_select.gender': 'Giới tính',
    'exchange.exchange_select.lock': 'Khóa định danh',
    'exchange.exchange_select.date_of_birth': 'Ngày sinh',
    'exchange.exchange_select.setting': 'Cài đặt',
    'exchange.exchange_select.light_theme': 'Nền trắng',
    'exchange.exchange_select.fast_order_book': 'Sổ lệnh nhanh',
    'exchange.exchange_select.show_open_orders': 'Hiện lệnh mở',
    'exchange.exchange_select.show_indicators': 'Hiển thị chỉ dẫn',
    'exchange.exchange_select.quick_overview': 'Giới thiệu nhanh',
    'exchange.exchange_select.main': 'Phần chính',
    'exchange.exchange_select.total_balance': 'Tổng số dư',

    'exchange.order_buy_limit.available': 'Có sẵn',
    'exchange.order_buy_limit.price_field_is_required': 'Giá là trường bắt buộc',
    'exchange.order_buy_limit.price': 'Giá',
    'exchange.order_buy_limit.amount_field_is_required': 'Số lượng không hợp lệ',
    'exchange.order_buy_limit.amount': 'Số lượng',
    'exchange.order_buy_limit.total_field_is_required': 'Tổng là trường bắt buộc',
    'exchange.order_buy_limit.total': 'Tổng',
    'exchange.order_buy_limit.buy': 'Mua',

    'exchange.order_sell_limit.available': 'Có sẵn',
    'exchange.order_sell_limit.price_field_is_required': 'Giá là trường bắt buộc',
    'exchange.order_sell_limit.price': 'Giá',
    'exchange.order_sell_limit.amount_field_is_required': 'Số lượng không hợp lệ',
    'exchange.order_sell_limit.amount': 'Số lượng',
    'exchange.order_sell_limit.total_field_is_required': 'Tổng là trường bắt buộc',
    'exchange.order_sell_limit.total': 'Tổng',
    'exchange.order_sell_limit.sell': 'Bán',

    'exchange.order_market.available': 'Có sẵn',
    'exchange.order_market.amount_field_is_required': 'Số lượng không hợp lệ',
    'exchange.order_market.amount': 'Số lượng',
    'exchange.order_market.buy': 'Mua',
    'exchange.order_market.sell': 'Bán',

    'exchange.order_stop_limit.available': 'Có sẵn',
    'exchange.order_stop_limit.stop_field_is_required': 'Giá dừng là trường bắt buộc',
    'exchange.order_stop_limit.stop': 'Giá dừng',
    'exchange.order_stop_limit.limit_field_is_required': 'Giá giới hạn là trường bắt buộc',
    'exchange.order_stop_limit.limit': 'Giá giới hạn',
    'exchange.order_stop_limit.amount_field_is_required': 'Số lượng là trường bắt buộc',
    'exchange.order_stop_limit.amount': 'Số lượng',
    'exchange.order_stop_limit.total_field_is_required': 'Tổng là trường bắt buộc',
    'exchange.order_stop_limit.total': 'Tổng',
    'exchange.order_stop_limit.buy': 'Mua',
    'exchange.order_stop_limit.sell': 'Bán',

    'exchange.order_confirm_question': 'Bạn có chắc muốn thực hiện giao dịch không?',

    'common.depth_chart': 'Biểu đồ chiều sâu',

    'exchange.right_panel.start_trading': 'BẮT ĐẦU GIAO DỊCH',
    'exchange.right_panel.login': 'Đăng nhập',
    'exchange.right_panel.welcome_sonek': 'Chào mừng tới sàn giao dịch tiền điện tử TrustKeys Network',
    'exchange.right_panel.the_exchange': 'Nơi trao đổi tiền điện tử mới nhất thế giới.',
    'exchange.right_panel.we_through': 'Chúng tôi cung cấp quyền truy cập cao cấp vào giao dịch tiền điện tử cho cả cá nhân và khách hàng tổ chức thông qua:',
    'exchange.right_panel.slogan': 'Sự kết hợp hoàn hảo của "Ví cá nhân bảo mật" với "Sàn giao dịch an toàn, nhanh chóng "',
    'exchange.right_panel.volume_based_structure': 'Cơ cấu phí dựa trên khối lượng',
    'exchange.right_panel.high_engine': 'Công cụ kết hợp hiệu suất cao',
    'exchange.right_panel.fix,_connectivity': 'Kết nối FIX, Websocket và HTTP API',
    'exchange.right_panel.24/7_support': 'Dịch vụ 24/7 và hỗ trợ cao cấp dành riêng',
    'exchange.right_panel.industry_leading_practices': 'Thực hành bảo mật hàng đầu trong ngành',
    'exchange.right_panel.new_order': 'Đơn hàng mới',
    'exchange.right_panel.market': 'Thị trường',
    'exchange.right_panel.limit': 'Giới hạn',
    'exchange.right_panel.stop': 'Dừng',
    'exchange.right_panel.sell': 'Bán',
    'exchange.right_panel.buy': 'Mua',

    'exchange.order_book.price': 'Giá',
    'exchange.order_book.amount': 'Số lượng',
    'exchange.order_book.total': 'Tổng',
    'exchange.order_book.sum': 'Tổng tích lũy',

    'exchange.order_transaction.amount': 'Số lượng',
    'exchange.order_transaction.time': 'Thời gian',
    'exchange.order_transaction.price': 'Giá',

    'user.menu.user_security': 'Bảo mật cá nhân',
    'user.menu.user_wallet': 'Ví cá nhân',
    'user.menu.deposit': 'Thông tin nạp',
    'user.menu.withdrawal': 'Thông tin rút',
    'user.menu.deposit_history': 'Lịch sử nạp và rút',
    'user.menu.open_orders': 'Lệnh đang mở',
    'user.menu.order_trans_history': 'Lịch sử khớp lệnh',
    'user.menu.user_login_history': 'Lịch sử đăng nhập',
    'user.menu.order_history': 'Lịch sử lệnh',
    'user.menu.commission_history': 'Giới thiệu',

    'user.account_balance.coin': 'Đồng',
    'user.account_balance.name': 'Tên đồng',
    'user.account_balance.balance': 'Số dư',
    'user.account_balance.available_balance': 'Số dư có sẵn',
    'user.account_balance.action': 'Hành động',
    'user.account_balance.deposit': 'Nạp',
    'user.account_balance.withdrawal': 'Rút',
    'user.account_balance.account': 'Tài khoản chính',
    'user.account_balance.estimated_value': 'Giá ước lượng',
    'user.account_balance.24h_limit': 'Giới hạn 24h rút tiền',
    'user.account_balance.unlimited': 'Vô hạn',
    'user.account_balance.hide_assets': 'Ẩn các đồng có số dư thấp',
    'user.account_balance.coin_search': 'Tìm kiếm đồng',

    'user.deposit.deposit': 'Nạp',
    'user.deposit.coin': 'Đồng',
    'user.deposit.total_balance': 'Tổng số dư',
    'user.deposit.copy': 'Sao chép thành công',
    'user.deposit.available_balance': 'Số dư có sẵn',
    'user.deposit.tips': 'Mẹo',
    'user.deposit.coins_confirmations': 'Các đồng sẽ được gửi sau 1 lần xác nhận mạng',
    'user.deposit.until_withdrawals': 'Cho đến khi 2 xác nhận được thực hiện, một lượng tài sản tương đương của bạn sẽ tạm thời không có sẵn để rút tiền',
    'user.deposit.go_trade': 'Đi tới giao dịch',
    'user.deposit.select_network': 'Chọn mạng',
    'user.deposit.address': 'Địa chỉ {{coinSymbol}}',
    'user.deposit.pubkey': 'Pubkey {{pubkey}}',
    'user.deposit.recent_history': 'Lịch sử nạp gần nhất',
    'user.deposit.show_qr': 'Hiển thị mã quét địa chỉ',
    'user.deposit.send_only_addr': 'Chỉ gửi {{coinSymbol}} tới các địa chỉ nhận tiền.',
    'user.deposit.send_deposit': 'Gửi đồng hoặc token khác ngoài {{coinSymbol}} tới địa chỉ {{coinSymbol}} có thể dẫn tới mất số tiền mà bạn gửi vào địa chỉ trên',
    'user.deposit.currency': 'Tiền tệ',
    'user.deposit.copy_address': 'Sao chép địa chỉ tại đây',
    'user.deposit.fee': 'Phí',
    'user.deposit.amount': 'Số lượng',
    'user.deposit.status': 'Trạng thái',
    'user.deposit.deposit_date': 'Ngày nạp',
    'user.deposit.modal_title': 'Mã QR {{coinSymbol}} địa chỉ gửi tiền',
    'user.transaction.id': 'Mã',
    'user.withdrawal.withdrawal': 'Rút',
    'user.withdrawal.coin': 'Đồng',
    'user.withdrawal.total_balance': 'Tổng số dư',
    'user.withdrawal.tips': 'Mẹo',
    'user.withdrawal.coins_confirmations': 'Đồng sẽ được gửi sau 1 lần xác nhận mạng.',
    'user.withdrawal.until_withdrawals': 'Cho đến khi 2 xác nhận được thực hiện, một lượng tài sản tương đương của bạn sẽ tạm thời không có sẵn để rút tiền.',
    'user.withdrawal.go_trade': 'Đi tới giao dịch',
    'user.withdrawal.select_network': 'Chọn mạng',
    'user.withdrawal.average': 'Trung bình',
    'user.withdrawal.fast': 'Nhanh',
    'user.withdrawal.fastest': 'Siêu nhanh',
    'user.withdrawal.submit': 'Đồng ý gửi',
    'user.withdrawal.send_address': 'Chỉ gửi {{coinSymbol}} tới các địa chỉ nhận tiền.',
    'user.withdrawal.sending_deposit': 'Gửi đồng hoặc token khác ngoài {{coinSymbol}} tới địa chỉ {{coinSymbol}} có thể dẫn tới mất số tiền mà bạn gửi vào địa chỉ trên',
    'user.withdrawal.minimum_withdrawal': 'Số tiền rút nhỏ nhất',
    'user.withdrawal.available_balance': 'Số dư có sẵn',
    'user.withdrawal.transaction_fee': 'Phí giao dịch',
    'user.withdrawal.you_get': 'Bạn sẽ nhận',
    'user.withdrawal.you_pay': 'Bạn phải trả',
    'user.withdrawal.recent_history': 'Lịch sử rút gần nhất',
    'user.withdrawal.currency': 'Tiền tệ',
    'user.withdrawal.fee': 'Phí',
    'user.withdrawal.amount': 'Số lượng',
    'user.withdrawal.status': 'Trạng thái',
    'user.withdrawal.withdrawal_date': 'Ngày rút',
    'user.withdrawal.question': 'Bạn có chắc muốn thực hiện giao dịch không?',
    'user.withdrawal.label_receive_address': 'Địa chỉ {{coinSymbol}} của người nhận:',
    'user.withdrawal.label_pubkey': 'Pubkey của người nhận:',
    'user.withdrawal.detail': 'Chi tiết',

    'user.deposit_and_withdrawal.currency': 'Tiền tệ',
    'user.deposit_and_withdrawal.fee': 'Phí',
    'user.deposit_and_withdrawal.amount': 'Số lượng',
    'user.deposit_and_withdrawal.status': 'Trạng thái',

    'user.deposit_and_withdrawal.deposit_history': 'Lịch sử nạp và rút',
    'user.deposit_and_withdrawal.transfer': 'Chuyển',
    'user.deposit_and_withdrawal.deposits': 'Nạp',
    'user.deposit_and_withdrawal.withdrawal': 'Rút',
    'user.deposit_and_withdrawal.coin': 'Đồng',
    // 'user.deposit_and_withdrawal.status': 'Status',
    'user.deposit_and_withdrawal.all': 'Tất cả',
    'user.deposit_and_withdrawal.success': 'Thành công',
    'user.deposit_and_withdrawal.pending': 'Đang xử lý',
    'user.deposit_and_withdrawal.submitted': 'Đã gửi',
    'user.deposit_and_withdrawal.error': 'Lỗi',
    'user.deposit_and_withdrawal.cancel': 'Hủy',
    'user.deposit_and_withdrawal.rejected': 'Từ chối',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_date': 'Thời gian',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_start_date': 'Bắt đầu',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_end_date': 'Kết thúc',
    'user.deposit_and_withdrawal.type': 'Loại giao dịch',
    
    'user.open_order.id': 'Mã lệnh',
    'user.open_order.open_order': 'Lệnh mở',
    'user.open_order.order_type': 'Loại lệnh',
    'user.open_order.transfer': 'Loại giao dịch',
    'user.open_order.pair': 'Cặp',
    'user.open_order.withdrawal': 'Giá',
    'user.open_order.coin': 'Số lượng',
    'user.open_order.quantity': 'Số lượng còn',
    'user.open_order.total': 'Tổng',
    'user.open_order.all': 'Khớp',
    'user.open_order.status': 'Trạng thái',
    'user.open_order.pending': 'Ngày',
    'user.open_order.action': 'Hành động',
    'user.open_order.created_at': 'Thời gian',
    'user.open_order.limit': 'Giới hạn',
    'user.open_order.stop_limit': 'Lệnh dừng',
    'user.open_order.market': 'Thị trường',
    'user.open_order.sell': 'Bán',
    'user.open_order.buy': 'Mua',
    'user.open_order.cancel_all': 'Hủy tất cả lệnh',

    'user.order_trans.id': 'Mã khớp lệnh',

    'user.open_order_exchange.open_order': 'Lệnh mở',
    'user.open_order_exchange.deposit_history': 'Lệnh',
    'user.open_order_exchange.transfer': 'Loại giao dịch',
    'user.open_order_exchange.deposits': 'Cặp',
    'user.open_order_exchange.withdrawal': 'Giá',
    'user.open_order_exchange.coin': 'Số lượng',
    'user.open_order_exchange.total': 'Tổng',
    'user.open_order_exchange.status': 'Trạng thái',
    'user.open_order_exchange.all': 'Khớp',
    'user.open_order_exchange.pending': 'Ngày',
    'user.open_order_exchange.action': 'Hành động',
    'user.open_order_exchange.title_modal': 'Xác nhận thông tin hủy lệnh cặp {{pair}}',
    'user.open_order_exchange.infor_cancel': 'Thông tin lệnh hủy',
    'user.open_order_exchange.order_state': 'Trạng thái lệnh',
    'user.open_order_exchange.matching_amount': 'Số lượng đã khớp',
    'user.open_order_exchange.rest_amount': 'Số lượng còn',
    'user.open_order_exchange.total_amount_order': 'Tổng đặt',
    'user.open_order_exchange.matched_percent': 'Phần trăm khớp',

    'user.login_history.agent_title': 'Tác nhân',
    'user.login_history.login_time_title': 'Thời gian đăng nhập',

    'user.commission_coin': 'Đồng',
    'user.commission_coin_value': 'Tổng',

    'ans_1.text_1': 'Tiền điện tử là gì?',
    'ans_1.text_2': 'Tiền điện tử là tiền đã được số hóa, tức là tiền ở dạng những bit số. Tiền điện tử chỉ được sử dụng trong môi trường điện tử phục vụ cho những thanh toán điện tử thông qua hệ thống thông tin bao gồm hệ thống mạng máy tính, Internet và các phương tiện điện tử được lưu trữ trong cơ sở dữ liệu của tổ chức phát hành (bên thứ 3). Điều này có nghĩa là, bạn không thể cầm nắm và chỉ có thể sử dụng trên môi trường điện tử.',
    'ans_1.text_3': 'Trên sàn TrustKeys hiện tại đang giao dịch với những loại coin nào?',
    'ans_1.text_4': 'Hiện tại, sàn giao dịch TrustKeys đang giao dịch với các đồng: BTC, USDT, KNC, ETH.',
    'ans_1.text_5': 'Ưu nhược điểm của tiền điện tử ?',
    'ans_1.text_6': 'Ưu điểm :',
    'ans_1.text_7': 'Tiền điện tử nhìn chung được xem là một sự tiến bộ về khoa học công nghệ đối với lĩnh vực tiền tệ, tài chính. Vì thế nó có những ưu điểm nhất định so với loại tiền giấy lưu hành hiện tại trên thị trường:',
    'ans_1.text_8': 'Thuận tiện trong giao dịch: Nếu khi gửi tiền tại các ngân hàng, bạn có thể bị giới hạn chuyển khoản, rút tiền... trong 1 ngày thì với tiền điện tử, bạn có quyền tự do giao dịch bất chấp không gian, thời gian.',
    'ans_1.text_9': 'Tiền điện tử không thể làm giả: Vì không tồn tại dưới dạng vật chất và mỗi đồng tiền điện tử tồn tại dưới 1 dãy bit mã hóa duy nhất trên Internet.',
    'ans_1.text_10': 'Độ bảo  mật an toàn cao, không bị lộ danh tính khi giao dịch ẩn danh.',
    'ans_1.text_11': 'Chi phí giao dịch cực thấp.',
    'ans_1.text_12': 'Khả năng sinh lời rất cao, đặc biệt đối với những đồng có giá trị nhỏ.',
    'ans_1.text_13': 'An toàn và bảo vệ môi trường.',
    'ans_1.text_14': 'Có tiềm năng phát triển thương mại điện tử.',
    'ans_1.text_15': 'Khuyết điểm:',
    'ans_1.text_16': 'Bên cạnh những ưu điểm kể trên thì tiền điện tử vẫn còn tồn tại một số nhược điểm. Điều này gây không ít khó khăn cho người dùng như:',
    'ans_1.text_17': 'Sử dụng không quá dễ dàng: Với những người đã quen sử dụng công nghệ thì vấn đề này không quá khó khăn. Nhưng đối với những ai ít có cơ hội tiếp xúc với công nghệ thì việc tạo ví tiền điện tử và quản lý lại khá khó khăn. Không cẩn thận còn bị lừa đảo 1 cách dễ dàng.',
    'ans_1.text_18': 'Giá tiền điện tử thường biến động lên xuống mà chúng ta rất khó để đoán trước được. Điều này gần giống với sự lên xuống của thị trường chứng khoán. Nhà đầu tư giao dịch có nguy cơ bị thua lỗ, mất vốn nếu không thường xuyên theo dõi biến động.',
    'ans_1.text_19': 'Là nơi cho tội phạm hoạt động rửa tiền: Có lẽ đây là nhược điểm lớn nhất. Cũng vì lý do này mà có những quốc gia chưa chấp nhận đồng coin là một loại tiền tệ hợp pháp.',
    'ans_1.text_20': 'Là mục tiêu hàng đầu của các hacker hiện nay cũng như gắn liền với các hoạt động bất hợp pháp khác.',
    'ans_1.text_21': 'Đầu tư dễ dẫn đến tình trạng bong bóng tài chính trên Internet.',
    'ans_1.text_22': 'Có nên đầu tư tiền điện tử?',
    'ans_1.text_23': 'Rất khó để nói rằng có nên đầu tư vào tiền điện tử trong thời điểm hiện tại hay không, đặc biệt là Bitcoin bởi vì các đồng tiền điện tử ra sau nhận được sự đầu tư, chuẩn bị kỹ lưỡng hơn đã qua mặt Bitcoin.',
    'ans_1.text_24': 'Nếu có một số tiền vừa phải hoặc nhỏ, bạn có thể đầu tư vào đồng tiền có giá trị trên thị trường còn thấp nhưng khả năng sinh lời sẽ cao và nhanh hơn so với những đồng tiền có giá trị lớn.',
    'ans_1.text_25': 'Tuy nhiên tiền điện tử không phải là một sự lựa chọn lý tưởng dành cho những người bận rộn bởi giá của đồng tiền luôn liên tục biến động. Nếu không theo dõi thường xuyên, khả năng sinh lời là rất thấp, thậm chí là bị thua lỗ nhanh chóng.',
    'ans_1.text_26': 'Vì vậy:',
    'ans_1.text_27': 'Bạn chỉ NÊN đầu tư khi có thời gian để theo dõi liên tục vì sự biến động của tiền điện tử rất lớn và cần thực sự hiểu về loại tiền mà mình đầu tư.',
    'ans_1.text_28': 'Bạn KHÔNG NÊN đầu tư theo phong trào khi chưa thực sự hiểu rõ tiền điện tử là gì và biết cách đánh giá thị trường, vì nguy cơ thua lỗ là rất cao nếu bạn không thực sự hiểu về loại tiền mà mình đầu tư và biết nắm bắt cơ hội đúng lúc.',

    'ans_2.text_1': 'Làm thế nào tôi có thể đăng nhập vào sàn TrustKeys?',
    'ans_2.text_2': 'Để thực hiện mua/bán coin trên sàn, đầu tiên bạn cần tải app TrustKeys, tạo tài khoản để có thể đăng nhập.',
    'ans_2.text_3': 'Link tải trên IOS:',
    'ans_2.text_4': 'Link tải trên Android:',
    'ans_2.text_5': 'Sau khi bạn tải xong app, bạn có thể nạp tiền vào ví và thực hiện quét mã QR code để giao dịch mua bán coin.',
    'ans_2.text_6': 'Làm thế nào tôi có thể giao dịch mua/bán coin?',
    'ans_2.text_7': 'Bạn cần chắc chắn là số dư trong ví đủ để bạn thực hiện giao dịch trên sàn, đối với sàn TrustKeys, bạn có thể giao dịch ít nhất với 0,0001 BTC. Sau đó, bạn có thể đặt mua coin với thị trường mà mình mong muốn.',
    'ans_2.text_8': 'Làm thế  nào tôi có thể giao dịch nạp/rút coin?',
    'ans_2.text_9': 'Để thực hiện rút coin bạn cần nhập vào số lượng cần rút và nhập địa chỉ mà tài khoản sẽ nhận được tiền, có hai hình thức là bạn quét mã QR code hoặc dán địa chỉ của người nhận, như vậy bạn có thể rút tiền một cách an toàn.',
    'ans_2.text_10': 'Để thực hiện nạp tiền, bạn chỉ cần quét mã QR code hoặc dán địa chỉ của mình để có thể nạp tiền.',

    'ans_3.text_1': 'Mời bạn bè tham gia vào sàn như thế nào?',
    'ans_3.text_2': 'Rất đơn giản, bạn có thể gửi thông tin của mình trong danh mục “ Thêm bạn” trên app, nhấn “ Chia sẻ ngay” đến người bạn mà bạn muốn gửi.',
    'ans_3.text_3': 'Mời bạn bè sử dụng sàn tôi sẽ được những lợi ích như thế nào?',
    'ans_3.text_4': 'Nếu bạn mời bạn bè sử dụng sàn TrustKeys, bạn sẽ được hưởng  hoa hồng và những tiện ích mà bạn không tưởng đến. Khi giới thiệu bạn bè sử dụng sàn TrustKeys, bạn sẽ được hưởng 30% phí giao dịch khi người bạn mời thực hiện giao dịch trên sàn. Ngoài ra, bạn sẽ nhận được 20% phí giao dịch trên sàn của người khác nếu  người bạn của bạn giới thiệu cho người đó. Nhanh tay mời bạn bè tham gia sử dụng sàn TrustKeys nào!',

    'ans_4.text_1': 'Sàn TrustKeys có an toàn không?',
    'ans_4.text_2': 'Khi thực hiện giao dịch với sàn TrustKeys, bạn có thể mua/bán coin một cách an toàn và thông minh, TrustKeys sử dụng các thuật toán mã hóa vô cùng bảo mật nên bạn có thể yên tâm khi thực hiện các giao dịch trên sàn.',
    'ans_4.text_3': 'Trên sàn TrustKeys hiện tại đang giao dịch với những loại coin nào?',
    'ans_4.text_4': 'Hiện tại, sàn giao dịch TrustKeys đang giao dịch với các đồng: BTC, USDT, KNC, ETH.',
    'ans_4.text_5': 'Ưu nhược điểm của tiền điện tử ?',
    'ans_4.text_6': 'Ưu điểm :',
    'ans_4.text_7': 'Tiền điện tử nhìn chung được xem là một sự tiến bộ về khoa học công nghệ đối với lĩnh vực tiền tệ, tài chính. Vì thế nó có những ưu điểm nhất định so với loại tiền giấy lưu hành hiện tại trên thị trường:',
    'ans_4.text_8': 'Thuận tiện trong giao dịch: Nếu khi gửi tiền tại các ngân hàng, bạn có thể bị giới hạn chuyển khoản, rút tiền... trong 1 ngày thì với tiền điện tử, bạn có quyền tự do giao dịch bất chấp không gian, thời gian.',
    'ans_4.text_9': 'Tiền điện tử không thể làm giả: Vì không tồn tại dưới dạng vật chất và mỗi đồng tiền điện tử tồn tại dưới 1 dãy bit mã hóa duy nhất trên Internet.',
    'ans_4.text_10': 'Độ bảo  mật an toàn cao, không bị lộ danh tính khi giao dịch ẩn danh.',
    'ans_4.text_11': 'Chi phí giao dịch cực thấp.',
    'ans_4.text_12': 'Khả năng sinh lời rất cao, đặc biệt đối với những đồng có giá trị nhỏ.',
    'ans_4.text_13': 'An toàn và bảo vệ môi trường.',
    'ans_4.text_14': 'Có tiềm năng phát triển thương mại điện tử.',
    'ans_4.text_15': 'Khuyết điểm:',
    'ans_4.text_16': 'Bên cạnh những ưu điểm kể trên thì tiền điện tử vẫn còn tồn tại một số nhược điểm. Điều này gây không ít khó khăn cho người dùng như:',
    'ans_4.text_17': 'Sử dụng không quá dễ dàng: Với những người đã quen sử dụng công nghệ thì vấn đề này không quá khó khăn. Nhưng đối với những ai ít có cơ hội tiếp xúc với công nghệ thì việc tạo ví tiền điện tử và quản lý lại khá khó khăn. Không cẩn thận còn bị lừa đảo 1 cách dễ dàng.',
    'ans_4.text_18': 'Giá tiền điện tử thường biến động lên xuống mà chúng ta rất khó để đoán trước được. Điều này gần giống với sự lên xuống của thị trường chứng khoán. Nhà đầu tư giao dịch có nguy cơ bị thua lỗ, mất vốn nếu không thường xuyên theo dõi biến động.',
    'ans_4.text_19': 'Là nơi cho tội phạm hoạt động rửa tiền: Có lẽ đây là nhược điểm lớn nhất. Cũng vì lý do này mà có những quốc gia chưa chấp nhận đồng coin là một loại tiền tệ hợp pháp.',
    'ans_4.text_20': 'Là mục tiêu hàng đầu của các hacker hiện nay cũng như gắn liền với các hoạt động bất hợp pháp khác.',
    'ans_4.text_21': 'Đầu tư dễ dẫn đến tình trạng bong bóng tài chính trên Internet.',
    'ans_4.text_22': 'Giao dịch trên sàn tôi sẽ được lợi ích gì?',
    'ans_4.text_23': 'Thuận tiện trong giao dịch.',
    'ans_4.text_24': 'Khả năng sinh lời rất cao, đặc biệt đối với những đồng có giá trị nhỏ.',
    'ans_4.text_25': 'Độ bảo mật an toàn cao, không bị lộ danh tính khi giao dịch ẩn danh.',
    'ans_4.text_26': 'Có tiềm năng phát triển thương mại điện tử.',

    'ans_5.text_1': 'Điều kiện để thực hiện với sàn giao dịch TrustKeys?',
    'ans_5.text_2': 'Người tham gia thực hiện giao dịch với tiền điện tử trên sàn TrustKeys cần phải thực hiện đúng nội quy, quy định, pháp lý về tiền điện tử tại Việt Nam.',

    'ans_title.text_1': 'Giao dịch tiền điện tử là gì?',
    'ans_title.text_2': 'Cách giao dịch trên sàn như thế nào?',
    'ans_title.text_3': 'Mời bạn bè cùng tham gia vào sàn như thế nào?',
    'ans_title.text_4': 'Thực hiện trên sàn bạn có những lợi ích gì?',
    'ans_title.text_5': 'Điều kiện để thực hiện với sàn giao dịch TrustKeys?',
    'ans_title.text_6': 'Phí giao dịch trên sàn điện tử?',
    
    'market.favorite': 'Yêu thích',
    'market.market': 'Thị trường',
    'market.volume': 'Khối lượng',

    'question_answer.title': 'Tôi có thể giúp gì cho bạn',
    'question_answer.placeholder': 'Nhập từ khóa...',

    'user.order_tran.title': 'Lịch sử khớp lệnh',
    'user.order.title': 'Lịch sử lệnh',

    'model.cancel_order_success': 'Hủy đơn đặt hàng thành công',
    'model.cancel_order_null': 'Không có lệnh đang xử lý',
    deposit_fee: 'Phí nạp',
    withdrawal_fee: 'Phí rút',
    free: 'Miễn phí',
    'ans_6.text_1': 'Phí mua bán coin',
    'ans_6.text_2': 'Phí giao dịch mua và bán coin=0.5% tổng số tiền giao dịch.',
    'ans_6.text_3': 'Phí nạp tiền vào ví',
    'ans_6.text_4': 'Phí rút tiền từ ví',

    Succeed: 'Thành công',
    Submitted: 'Đã gửi',
    Cancel: 'Hủy',
    cancel_order: 'Hủy lệnh',
    Pending: 'Đang xử lý',
    Executed: 'Đã khớp',
    Executing: 'Đang thực thi',
    Market: 'Thị trường',
    Limit: 'Giới hạn',
    'Stop Limit': 'Lệnh dừng',
    'pending.order': 'Lệnh chờ khớp',
    Sell: 'Bán',
    Buy: 'Mua',
    Stopping: 'Đang dừng',
    Error: 'Lỗi',
    Canceled: 'Đã hủy',
    'common.notification': 'Thông báo',
    'common.view_all': 'Xem tất cả',
    'common.confirm': 'Xác nhận',
    'common.cancel': 'Huỷ bỏ',
    'common.empty': 'Trống',
    'common.previous': 'Trước đó',
    'Balance insufficient': 'Số dư của bạn không đủ',
    'Withdraw succeeded': 'Rút tiền thành công',

    'commission.total_receive': 'Toàn bộ hoa hồng nhận được',
    'commission.total_receive_in_time_duration': 'Hoa hồng nhận được trong một khoảng thời gian',

    validate_invalid_address: 'Địa chỉ không hợp lệ',
    validate_invalid_pubkey: 'Pubkey không hợp lệ',
    BLOCK_CHAIN_ADDRESS_NOT_EXIST_ERROR: 'Địa chỉ không hợp lệ',

    'Add order succeeded': 'Thêm lệnh thành công',
    'Cancel order failed': 'Hủy đơn hàng không thành công',
    'View more': 'Xem thêm',
    'Amount invalid': 'Số lượng không hợp lệ',

    'validate.stop_less_than': 'Giá dừng phải nhỏ hơn giá giới hạn',
    'validate.stop_more_than': 'Giá dừng phải lớn hơn giá giới hạn',

    greedy: 'Xin chào',

    Show: 'Hiện số dư',
    Hide: 'Ẩn số dư',

    'message.matching_order_title': 'Khớp lệnh',
    'message.transaction_deposit_title': 'Nhận tiền thành công',
    'message.transaction_withdrawal_title': 'Rút tiền thành công',
    // 'message.matching_order': 'Khớp lệnh thành công với giá {{price}} {{currency}} số lượng {{quantity}} {{coin}} tổng {{amount}} {{currency}}',
    'message.matching_order': 'Khớp lệnh thành công',
    'message.transaction_deposit': 'Nhận tiền thành công với số lượng {{quantity}} {{currency}}',
    'message.transaction_withdrawal': 'Rút thành công với số lượng {{quantity}} {{currency}} tới địa chỉ {{address}}',

    'market.all': 'Tất cả',

    notification_page: 'Thông báo',
    'notify_page.hide_read_notifications': 'Ẩn thông báo đã đọc',
    'notify_page.mark_all_as_read': 'Đánh dấu tất cả đã đọc',
    'notify_page.clear_all': 'Xóa tất cả thông báo',
    'notify_page.system_messages': 'Thông báo hệ thống',
    'notify_page.trade_notification': 'Thông báo giao dịch',
    'notify_page.view_more': 'Xem thêm',
    'notify_page.confirm.mark_all_as_read': 'Bạn có chắc chắn muốn đánh dấu tất cả đã đọc?',
    'notify_page.confirm.clear_all': 'Bạn có chắc chắn muốn xóa tất cả thông báo?',
    'notify_page.confirm.ok': 'Đồng ý',
    'notify_page.confirm.cancel': 'Hủy bỏ',
    'notify_page.empty': 'Không có dữ liệu',

    referral: 'Giới thiệu',
    'referral.header.right.text_1.1': 'Mời bạn bè.',
    'referral.header.right.text_1.2': 'Cùng nhau kiếm tiền điện tử',
    'referral.header.right.text_2': 'Nhận đến 40% hoa hồng mỗi ngày khi thực hiện giao dịch trên Trustkey',
    'referral.header.right.button_1': 'Quy định chi tiết',
    'referral.header.right.button_2': 'Giới thiệu ngay',
    'referral.header.left.text_1': 'ID giới thiệu mặc định',
    'referral.header.left.text_2': 'Liên kết mặc định',
    'referral.header.left.button_1': 'Tạo liên kết của bạn',
    'referral.header.left.note': 'Lưu ý',
    'referral.header.left.card_1': 'Bạn nhận được',
    'referral.header.left.card_2': 'Bạn bè nhận được',
    'referral.menu.link_1': 'Tổng quan',
    'referral.menu.link_2': 'Danh sách liên kết giới thiệu',
    'referral.menu.link_3': 'Danh sách bạn bè',
    'referral.menu.link_4': 'Giới thiệu',
    'referral.menu.link_5': 'Phí hoa hồng được chia sẻ với bạn',
    'referral.body.all_accounts': 'Tất cả tài khoản',
    'referral.body.link_1.tabs_1': 'Bạn đã nhận được',
    'referral.body.link_1.tabs_2': 'Tổng số lượng bạn bè đã giao dịch',
    'referral.body.link_1.tabs_3': 'Tổng số bạn bè',
    'referral.body.link_1.tabs_4': 'Thứ hạng của bạn',
    'referral.body.link_1.text_1': 'Thời gian cập nhật dữ liệu sẽ theo múi giờ UTC+0. Thời gian bảo trì là từ 0am - 2am (UTC+0) mỗi ngày. Trong khoảng thời gian này, quá tình tính toán dữ liệu sẽ dựa trên tài sản của ngày hôm trước. Sau khi bảo trì, tất cả dữ liệu sẽ được hiển thị chính xác',
    'referral.body.link_1.text_2': 'Thông báo: vì sự phức tạp của dữ liệu tài chính, có thể sẽ có phiền thoái và trì hoãn. Dữ liệu hiển thị ở trên chỉ vì mục đích tham khảo. Chúng tôi chân thành xin lỗi vì những bất tiện có thể gây ra.',
    'referral.body.link_2.columns_1': 'Số lượng liên kết quảng bá còn lại có thể tạo',
    'referral.body.link_2.columns_2': 'ID giới thiệu',
    'referral.body.link_2.columns_3': 'Bạn nhận được, bạn bè nhận được',
    'referral.body.link_2.columns_4': 'Lưu ý',
    'referral.body.link_2.columns_5': 'Bạn bè',
    'referral.body.link_3.columns_1': 'Loại tài khoản',
    'referral.body.link_3.columns_2': 'ID Người dùng của bạn bè',
    'referral.body.link_3.columns_3': 'Phần thưởng giới thiệu đã nhận (BTC)',
    'referral.body.link_3.columns_4': 'Đã giao dịch',
    'referral.body.link_3.columns_5': 'Thời gian đăng ký',
    'referral.body.link_4.columns_1': 'Loại lệnh',
    'referral.body.link_4.columns_2': 'ID Người dùng của bạn bè',
    'referral.body.link_4.columns_3': 'Hoa hồng đã nhạn',
    'referral.body.link_4.columns_4': 'Thời gian trả hoa hồng',
    'referral.body.link_5.columns_1': 'Phí hoa hồng',
    'referral.body.link_5.columns_2': 'Thời gian',
    'referral.body.link_3.': 'Phí hoa hồng được chia sẻ với bạn',
    'referral.body.link_5': 'Phí hoa hồng được chia sẻ với bạn',
    'referral.body.link_5': 'Phí hoa hồng được chia sẻ với bạn',
    'referral.body.link_5': 'Phí hoa hồng được chia sẻ với bạn',
    //
    'referral.withoutlogin.download': 'Quét để tải xuống',
    'referral.withoutlogin.invite.title': 'Mời bạn bè tham gia Trustkeys và kiếm 20% phí giao dịch',
    'referral.withoutlogin.invite.des':'Cho dù bạn là một nhà giao dịch, HODLer hay là 1 fan Trustkeys khó tính, bạn có thể mời bạn bè tham gia Trustkeys và kiếm tiền từ phí giao dịch của họ. Bạn sẽ kiếm được 20% từ phí giao dịch của bạn bè và họ sẽ kiếm lại được 10%. Đó là một kết quả đôi bên cùng có lợi.',
    'referral.withoutlogin.button':'Mời bạn bè',
    'referral.withoutlogin.work.title': 'Cách thức hoạt động?',
    'referral.withoutlogin.work.col_1.title' : 'Mã giới thiệu',
    'referral.withoutlogin.work.col_1.des':'Tất cả khách hàng của Trustkeys đều có thể  lấy mã giới thiệu của họ từ phần cài đặt tài khoản. Đăng nhập vào Trustkeys để tìm mã giới thiệu của bạn.',
    'referral.withoutlogin.work.col_2.title' : 'Mời bạn bè',
    'referral.withoutlogin.work.col_2.des':'Chia sẻ mã giới thiệu của bạn với bạn bè, gia đình trên các mạng xã hội của bạn. Mỗi người đăng ký bằng mã giới thiệu của bạn sẽ là một người mà bạn có thể kiếm tiền từ đó.',
    'referral.withoutlogin.work.col_3.title' : 'Bắt đầu kiếm tiền',
    'referral.withoutlogin.work.col_3.des':'Những người bạn giới thiệu sẽ được chiết khấu 10% phí giao dịch trên Trust key và bạn sẽ kiếm được 20% phí giao dịch mà họ phải trả, lên tới tối đa là 5.000 USDT.',
    'referral.withoutlogin.work.col_4.title' : 'Mở rộng mạng lưới',
    'referral.withoutlogin.work.col_4.des':'Bạn càng chia sẻ nhiều, bạn càng kiếm được nhiều tiền. Hãy tiếp tục chia sẻ mã giới thiệu của bạn để duy trì thu nhập.',
    'referral.withoutlogin.details.title' : 'Chi tiết chương trình',
    'referral.withoutlogin.details.text_1' : 'Phần thưởng sẽ được trả cho người mời và người được giới thiệu một lần mỗi ngày bằng USDT.',
    'referral.withoutlogin.details.text_2' : 'Phần thưởng được tính dựa trên phí net spot (giao dịch giao ngay) và phí margin trading (giao dịch ký quỹ) do người giới thiệu trả. Để biết thêm chi tiết về cách tính phần thưởng, vui lòng truy cập bài viết trong Trung tâm trợ giúp',
    'referral.withoutlogin.details.text_3' : 'Cả người mời và người được giới thiệu đều đủ điều kiện để nhận phần thưởng trong tối đa 180 ngày kể từ ngày đăng ký của người được giới thiệu hoặc cho đến khi người mời và người được giới thiệu cùng nhau kiếm được tổng cộng 5.000 USDT.',
    'referral.withoutlogin.details.text_4' : 'Mỗi khách hàng của Trustkeys có thể mời bao nhiêu bạn bè tùy thích! Không có giới hạn về số lượng giới thiệu mà một tài khoản có thể có.',
    'referral.withoutlogin.details.text_5' : 'Khách hàng không thể tự mời chính bản thân để kiếm phần thưởng bằng cách lập nhiều tài khoản. Khi hành vi này bị phát hiện, bạn sẽ bị loại khỏi Chương trình giới thiệu và tất cả phần thưởng giới thiệu bị hủy ngay lập tức.',
    'referral.withoutlogin.details.text_6' : 'Khách hàng không thể mời các tài khoản do khách hàng Trustkeys hiện có sở hữu hoặc kiểm soát. Khi hành vi này bị phát hiện, bạn sẽ bị loại khỏi Chương trình giới thiệu và tất cả phần thưởng giới thiệu bị hủy ngay lập tức.',
    'referral.withoutlogin.details.text_7' : 'Chúng tôi không chấp nhận các lượt giới thiệu và trả phần thưởng cho các tài khoản khách hàng bị đóng băng, bị đóng băng hoặc có trụ sở tại một quốc gia trong danh sách các quốc gia bị cấm. Để biết thêm chi tiết, vui lòng tham khảo Thỏa thuận người dùng',
    'referral.withoutlogin.details.text_8' : 'Trustkeys bảo lưu quyền sửa đổi các quy tắc hoặc phần thưởng của Chương trình này vào bất kỳ thời điểm nào bằng cách cập nhật chương trình tại https://support.poloniex.com/hc/articles/360047134473',
    'referral.withoutlogin.details.text_9' : 'Để biết thêm Điều khoản & Điều kiện về Chương trình Giới thiệu của chúng tôi, vui lòng truy cập Trung tâm Trợ giúp',

    tutorial_watch_more: 'Xem thêm hướng dẫn',
  },
};
